import * as d3 from 'd3'
import swal from 'sweetalert'

import { selectedFeatureId } from '../helperFunctions'
import { getScrollbarStatus, scrollBars, setScrollbarStatus } from './layers'
import { addMarkers } from './markers'
import {
  collection, CURRENT_GEOTYPE, currentLayerId, currentToolbarWindow,
  debug, highlighted, setHighlighted,
  layerStyle, locallyAr5, maxEditResolution, path, setD3Path
} from '../storage'
import { boundaryColour } from '../styles'
import { map } from './tools'

let d3Feature, svg;
export let defs;
export let g;

let colourMap = [];
// const colours = d3.scale.category20();
const colours = d3.scaleOrdinal(d3.schemeCategory10);

let referencePixel, referencePoint;

export const initD3 = () => {
  const overlay = d3.select('div.ol-viewport').append('div').attr('id', 'overlay');
  svg = overlay.append('svg');
  g = svg.append('g').attr('id', 'd3-map');

  defs = svg.append('defs');

  // Add markers that are used in CSS styles
  addMarkers(defs);

  defs.append('pattern').attr('id', 'nothing').append('rect').attr({
    width: '1.5', height: '10', transform: 'translate(0,0)', fill: '#00734C'
  });

  setTimeout(() => {
    map.on('postrender', (event) => {
      if (!tabHome.classList.contains('active')) {
        if (complete) {
          resetSVG('complete');
          complete = false; // reset to true on new data received
        } else {
          if (!map.getView().getInteracting() && !map.getView().getAnimating()) {
            // console.log('map is loading new WMTS tiles, no need to reset svg');
          } else {
            // Do not re-draw circles and polylines for a smoother interaction:
            resetSVG('fast');
          }
        }
      }
    });
  }, 10);
};

// Reposition the SVG to cover the features.
export function resetSVG(type) {
  if (debug < 7) { console.log('resetSVG', type ? type : 'complete'); }
  if (tabHome.classList.contains('active')) return;

  if (!collection || Object.keys(collection).length === 0) return;
  if (!path) return;
  const bounds = path.bounds(collection);
  const topLeft = bounds[0], bottomRight = bounds[1];

  // We add buffer so that features do not get clipped at bounds
  const slideSVGWindowSize = 50;
  const bufferSize = slideSVGWindowSize + 50;

  svg.attr('width', bottomRight[0] - topLeft[0] + bufferSize)
    .attr('height', bottomRight[1] - topLeft[1] + bufferSize)
    .style('left', topLeft[0] - slideSVGWindowSize + 'px')
    .style('top', topLeft[1] - slideSVGWindowSize + 'px');

  // Translate the entire SVG layer
  const tx = -(topLeft[0] - slideSVGWindowSize);
  const ty = -(topLeft[1] - slideSVGWindowSize);
  g.attr('transform', 'translate(' + tx + ',' + ty + ')');

  if (CURRENT_GEOTYPE === 'point') {
    // Calculate pixel movement from reference pixel
    // We use this to translate each point below
    let xDiff, yDiff;
    if (typeof referencePixel !== 'undefined') {
      const newReferencePixel = map.getPixelFromCoordinate(referencePoint);
      xDiff = referencePixel[0] - newReferencePixel[0];
      yDiff = referencePixel[1] - newReferencePixel[1];
    } else {
      xDiff = 0;
      yDiff = 0;
    }

    if (d3Feature) {
      // Translate the individual point features
      if (xDiff === 0) {
        d3Feature.attr('transform', 'translate(' + -10 + ',' + 8 + ')');
        xDiff = -1;
      } else {
        d3Feature.attr(
          'transform', 'translate(' + -(xDiff + 10) + ',' + -(yDiff - 8) + ')'
        );
      }
    }
  } else {
    if (d3Feature) d3Feature.attr('d', path);

    // Remove old circles and polylines and redraw them if necessary
    const c = g.selectAll('circle');
    const p = g.selectAll('polyline');
    if (type === 'fast') {
      // // Translate circles and polylines:
      // const tx = (topLeft[0]-slideSVGWindowSize);
      // const ty = (topLeft[1]-slideSVGWindowSize);
      // c.attr('transform', 'translate(' + tx + ',' + ty + ')');
      // p.attr('transform', 'translate(' + tx + ',' + ty + ')');
      c.style('opacity', 0);
      p.style('opacity', 0);
      return;
    }
    c.remove();
    p.remove();

    // Draw circles along line
    // sperregjerde
    $.each($('#d3-map .RAN_L_anleggstype_1'), function(index, line) {
      const totalLength = line.getTotalLength();
      for (let i = 1; i < totalLength; i += 20) {
        const myPoint = line.getPointAtLength(i);
        d3.select('#d3-map')
          .append('svg:circle')
          .attr('cx', myPoint.x)
          .attr('cy', myPoint.y)
          .style('stroke', 'black')
          .style('fill', 'none')
          .attr('r', 4.5);
      }
    });

    // Draw circles along line
    // midlertidig sperregjerde
    $.each($('#d3-map .RAN_L_anleggstype_2'), function(index, line) {
      const totalLength = line.getTotalLength();
      const spacing = 40;
      if (totalLength > spacing) {
        for (let i = spacing; i < totalLength; i += spacing) {
          const myPoint = line.getPointAtLength(i);
          d3.select('#d3-map')
            .append('svg:circle')
            .attr('cx', myPoint.x)
            .attr('cy', myPoint.y)
            .style('stroke', 'black')
            .style('fill', 'none')
            .attr('r', 4.5);
        }
      }
    });

    // Draw ticks along line
    // beitehage
    $.each($('#d3-map .RAN_L_anleggstype_3'), function(index, line) {
      const totalLength = line.getTotalLength();
      const spacing = 20;
      if (totalLength > spacing) {
        for (let i = spacing; i < totalLength; i += spacing) {
          const myPoint = line.getPointAtLength(i);
          d3.select('#d3-map')
            .append('polyline')       // attach a polyline
            .style('stroke', 'black')   // colour the line
            .style('fill', 'none')      // remove any fill colour
            .style('stroke-width', 3)  // line width
            .style('stroke-linejoin', 'round')  // shape the line join
            .attr('points', (myPoint.x) +','+ (myPoint.y-6) +','+ (myPoint.x) +','+ (myPoint.y+6));  // x,y points
        }
      }
    });

    // Draw triangle along line
    // fangarm
    $.each($('#d3-map .RAN_L_anleggstype_4'), function(index, line) {
      const totalLength = line.getTotalLength();
      const spacing = 40;
      if (totalLength > spacing) {
        for (let i = spacing; i < totalLength; i += spacing) {
          const myPoint = line.getPointAtLength(i);
          d3.select('#d3-map')
            .append('polyline')       // attach a polyline
            .style('stroke', 'black')   // colour the line
            .style('fill', 'none')      // remove any fill colour
            .style('stroke-width', 3)  // line width
            .style('stroke-linejoin', 'round')  // shape the line join
            .attr('points', (myPoint.x-6) +','+ (myPoint.y-6) +','+ (myPoint.x) +','+ (myPoint.y+6)+','+ (myPoint.x+6) +','+ (myPoint.y-6));  // x,y points
        }
      }
    });
  }
}

function projectPoint(x, y) {
  const point = [x, y];
  const pixel = map.getPixelFromCoordinate(point);
  this.stream.point(pixel[0], pixel[1]);
}

function drawPoints() {
  // Reference point used to calculate how we should translate
  // individual points when the user pans the map
  referencePoint = map.getView().getCenter();
  referencePixel = map.getPixelFromCoordinate(referencePoint);

  // Update SVG
  d3Feature = g.selectAll('text')
  .data(collection.features)
  .enter()
  .append('text')
  .attr('x', d => {
    const point = [d.geometry.coordinates[0][0], d.geometry.coordinates[0][1]];
    const pixel = map.getPixelFromCoordinate(point);
    return pixel[0];
  })
  .attr('y', d => {
    const point = [d.geometry.coordinates[0][0], d.geometry.coordinates[0][1]];
    const pixel = map.getPixelFromCoordinate(point);
    return pixel[1];
  })
  .text(d => {
    // if (d.properties.slette_status_kode === 1) { console.log(d.properties.id); return null; }
    if (d.properties['newFeature']) {
      return 'N';
    } else {
      let character = '-';
      let v = d.properties[layerStyle.styleAttribute];
      if (typeof v === 'string' || v instanceof String) v = parseInt(v, 10);
      // Find the correct style to this feature
      layerStyle.styles.forEach(style => {
        if (v === style.value) character = style.char;
      });
      return character;
    }
  })

  .attr('transform', '')
  .attr('font-family', 'nibio')
  .attr('font-size', d => {
    const r = d.properties['reinbeitebruker_id'];
    const v = d.properties[layerStyle.styleAttribute];
    // r is undefined in AR5, keep 20px:
    const size = (r === null || !v) ? '40px' : '20px';
    return size;
  })

  .attr('fill', function(d) {
    let c = 'black';
    if (d.properties['id'] === selectedFeatureId) {
      d.properties['selected'] = true;
    }
    if (d.properties['selected']) c = 'red';
    else if (d.properties[layerStyle.styleAttributeDelete] === 1)
      c = 'white'; // return one common style for deleted objects
    else {
      let v = d.properties[layerStyle.styleAttribute];
      if (typeof v === 'string' || v instanceof String) v = parseInt(v, 10);
      // Find the correct style to this feature
      layerStyle.styles.forEach(style => {
        if (v === style.value) {
          if (style.colour) c = style.colour;
        }
      });
    }
    return c;
  });

  // .attr('style', function(d) {
  //   if (d.properties[layerStyle.styleAttributeDelete] === 1) {
  //     // return one common style for deleted objects
  //     return 'outline: thin solid black;';
  //   } else { return ''; }
  // });

  const transform = d3.geoTransform({ point: projectPoint });
  setD3Path(d3.geoPath().projection(transform));
}

function drawLines() {
  if (!layerStyle) return;
  if (debug < 16) console.log('drawLines');
  // Update SVG
  d3Feature = g.selectAll('path')
  .data(collection.features)
  .enter()
  .append('path')
  .attr('d', path)
  .attr('class', function(d) {
    const p = d.properties;
    // check if this object is active or not
    if (p[layerStyle.styleAttributeDelete] === 1) {
      // return one common style for deleted objects
      return 'deleteLineObject';
    } else { // return the correct style based on layer id and attribute value
      const styleAttribute = layerStyle.styleAttribute;
      if (styleAttribute === '') { // trekklei, for instance
        if (p['reinbeitebruker_id'] === null) {
          return 'ghostLine';
        } else {
          if (this.getTotalLength() > 40) return currentLayerId
          else return currentLayerId + '_no_arrow';
        }
      } else { // anleggstype linje, for instance
        if (!p[styleAttribute] || !p['reinbeitebruker_id'])
          return currentLayerId + '_' + styleAttribute + '_0';
        else
          return currentLayerId + '_' + styleAttribute + '_' + p[styleAttribute];
      }
    }
  }) // CSS class for polygons with no style
  .style('marker-end', function(d) {
    if (d.properties[layerStyle.styleAttributeDelete] === 1) {
      if (this.getTotalLength() > 40) {
        // return 'url(#deleteLineObject-end)';
        return 'deleteLineObject';
      } else return '';
    } else if (layerStyle.styleAttribute === '') {
      if (d.properties['reinbeitebruker_id'] === null) return '';
      else {
        if (this.getTotalLength() > 40) return 'url(#arrow-end)';
        else return '';
      }
    } else return '';
  })
  .style('marker-start', function(d) {
    if (d.properties[layerStyle.styleAttributeDelete] === 1) {
      if (this.getTotalLength() > 40) {
        // return 'url(#deleteLineObject-start)';
        return 'deleteLineObject';
      } else return '';
    } else if (layerStyle.styleAttribute === '') {
      if (d.properties['reinbeitebruker_id'] === null) return '';
      else {
        if (this.getTotalLength() > 40) { return 'url(#arrow-start)'; }
        else return '';
      }
    } else return '';
  });

  const transform = d3.geoTransform({ point: projectPoint });
  setD3Path(d3.geoPath().projection(transform));
}

function drawPolygons() {
  if (!layerStyle || !collection || !collection.features) return 0;
  if (map.getView().getResolution() > maxEditResolution) return;
  if (debug < 10) console.log('drawPolygons', collection.features);
  // Update SVG
  d3Feature = g.selectAll('path')
  .data(collection.features)
  .enter()
  .append('path')
  .attr('d', path)
  .style('fill', 'transparent')
  .style('stroke', 'black')
  .style('stroke-width', 1)
  .style('stroke-linejoin', 'round')
  // .on('mouseover', function(){
         // d3.select(this)
             // .style('fill', 'url(#vaarbeite1)');
  // })
  .on('click', (e, d) => {
    if (debug < 13) console.log('click', e.target, d.properties);
    if (locallyAr5 && (currentToolbarWindow !== 'info')) return;
    setHighlighted(0);
    const editingCard = document.getElementById('info-box-object-attributes');
    if (editingCard.style.display === 'block') return;
    lowlight();
    const drawingCard = document.getElementById('info-box-text');
    if (drawingCard.style.display === 'block') return;
    const editingLine = document.getElementById('info-box-line-attributes');
    if (editingLine.style.display === 'block') return;
    highlight(e.target, d.properties.id);
  })
  .style('fill', function(d, i) {
    let s = '';
    if ((d.properties.reinbeitebruker_id === null) && !locallyAr5) { } // missing property, use ghost style
    else {
      s = 'transparent'; // only random colour is still d3 and not ol
      const distinguishingProperty = d.properties[layerStyle.styleAttribute];
      // Find the correct style to this feature
      layerStyle.styles.forEach(style => {
        if (style.fillColor === 'random') {
          s = assignColourToId(distinguishingProperty, i);
        }
      });
    }
    return s;
  })
  .style('fill-opacity', function(d) {
    // if (locallyAr5) return (document.getElementById('rangePG').value / 100);
    // AR5 uses Openlayers to fill, such that symbols do not get hidden:
    if (locallyAr5) return 0;
    if (d.properties['reinbeitebruker_id'] === null) { // missing property, use ghost style
      return 0.8; // black
    }
    const ls = layerStyle.styles;
    if (ls.length === 1 && ls[0].fillColor === 'random') return 0.3;
    return 1;
  })
  .style('stroke', strokeColorChoice)
  .style('stroke-width', layerStyle.styles[0].strokeWidth)
  .style('stroke-dasharray', (layerStyle.styles[0].dasharray));

  const transform = d3.geoTransform({ point: projectPoint });
  setD3Path(d3.geoPath().projection(transform));
}

function highlight(geometry, id) {
  const d3g = d3.select(geometry);
  // Get style attribute: d3g.style('fill')
  // Get whole style as string: d3g.attr('style')
  d3g.attr('originalStyle', d3g.attr('style'));
  d3g.style('stroke-width', 4).style('stroke', 'red');
  // .style('fill', 'rgba(0, 0, 255, 0.1)')
  const parent = geometry.parentElement;
  if (parent) parent.appendChild(geometry); // borders on top of others
  setHighlighted(id);
}

export function highlightId(id) {
  if (debug < 12) console.log('highlightId');
  d3.selectAll('path').each(function(d) {
    const path = this;
    if (d?.properties?.id === id) highlight(path, id);
  });
}

const lowlight = () => d3Feature.style(
  'stroke-width', layerStyle.styles[0].strokeWidth
).style('stroke', strokeColorChoice);

export function lowlightId(id) {
  // d3.selectAll('path').each((d, i, nodes) => { // we need d3 version >= 1.4.1
  //   const path = nodes[i];
  d3.selectAll('path').each(function(d) {
    const path = this;
    if (d?.properties?.id === id) {
      const d3g = d3.select(path);
      const originalStyle = d3g.attr('originalStyle');
      if (originalStyle) d3g.attr('style', originalStyle);
    }
  });
}

function idHasColour(id) {
  for (let i = 0, l = colourMap.length; i < l; i++) {
    if (id === colourMap[i].id) return i;
  }
  return -1;
}

function assignColourToId(prop, i) {
  if ( (prop === undefined) || (prop === '') ) {
    // console.log('distinguishing property not defined in style file');
    return colours(i);
  }
  const idx = idHasColour(prop);
  if ( idx > -1 ) return colourMap[idx].colour;
  const c = colours(colourMap.length);
  colourMap.push({ id: prop, colour: c });
  return c;
}

function colourFromId(id) {
  for (let i = 0, l = colourMap.length; i < l; i++) {
    if (id === colourMap[i].id) return colourMap[i].colour;
  }
  return 'black';
}

const strokeColorChoice = function(d, i) {
  const style = layerStyle.styles[0];
  let c = style.strokeColor;
  // console.log('Choosing colours according to', layerStyle.styleAttribute);
  const distinguishingProperty = d.properties[layerStyle.styleAttribute];
  if (c === 'random') {
    c = assignColourToId(distinguishingProperty, i);
  }
  if (locallyAr5) {
    const [bc, z] = boundaryColour(layerStyle.orthophoto, d.properties);
    if (bc) {
      c = bc; // use it
      // take geometry on top of the others:
      this.parentElement.appendChild(this);
    }
    c = 'transparent'; // hide it here and use Openlayers
  }
  return c;
}

let complete = true;
export const setComplete = (c) => complete = c;

export function updateSVG() {
  complete = true;
  // Remove old SVG object
  g.selectAll('path').remove();
  g.selectAll('text').remove();

  if (tabHome.classList.contains('active')) return;
  if (CURRENT_GEOTYPE === 'point') drawPoints();
  else if (CURRENT_GEOTYPE === 'line') drawLines();
  else if (CURRENT_GEOTYPE === 'surface') drawPolygons();
  else swal({
    title: 'Error!',
    text: 'Ukjent geometritype: ' + CURRENT_GEOTYPE,
    type: 'error',
    confirmButtonText: 'Ok'
  });
  // resizeMap();
  if (highlighted > 0) highlightId(highlighted);
}

export const resizeMap = () => {
  // fix the shift between areas and contours
  const vScrollbar = getScrollbarStatus('vScrollbar');
  const no_vScrollbar = getScrollbarStatus('no_vScrollbar');
  const hScrollbar = getScrollbarStatus('hScrollbar');
  const no_hScrollbar = getScrollbarStatus('no_hScrollbar');
  if (scrollBars().vertical && vScrollbar === false) {
    map.updateSize();
    setScrollbarStatus('vScrollbar', true);
    setScrollbarStatus('no_vScrollbar', false);
  }
  if (!scrollBars().vertical && no_vScrollbar === false) {
    map.updateSize();
    setScrollbarStatus('vScrollbar', false);
    setScrollbarStatus('no_vScrollbar', true);
  }
  if (scrollBars().horizontal && hScrollbar === false) {
    map.updateSize();
    setScrollbarStatus('hScrollbar', true);
    setScrollbarStatus('no_hScrollbar', false);
  }
  if (!scrollBars().horizontal && no_hScrollbar === false) {
    map.updateSize();
    setScrollbarStatus('hScrollbar', false);
    setScrollbarStatus('no_hScrollbar', true);
  }
  return;
};
